import React, { useState } from 'react';
import api from '../utils/api';
import { toast } from 'react-toastify';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handle = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/contact', form);
      toast.success('Message sent! We\'ll reply within 1-2 business days.');
      setForm({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Our research support team is here to help</p>
        </div>
      </div>
      <div className="container contact-layout section">
        {/* Info cards */}
        <div className="contact-info">
          {[['📧','Email Support','support@peptidelabpro.com','Response within 1-2 business days'],['📞','Phone','(+1) 800-PEPTIDE','Mon-Fri 9am-6pm EST'],['💬','Live Chat','Available on site','Typical response: under 5 minutes'],['🏢','Address','123 Research Blvd, Boston MA 02101','By appointment only']].map(([icon, title, val, note]) => (
            <div key={title} className="contact-info-card card">
              <div className="contact-info-icon">{icon}</div>
              <div>
                <h3>{title}</h3>
                <strong>{val}</strong>
                <p>{note}</p>
              </div>
            </div>
          ))}
          <div className="contact-info-card card">
            <div className="contact-info-icon">⏰</div>
            <div>
              <h3>Business Hours</h3>
              <strong>Mon – Fri: 9:00 AM – 6:00 PM EST</strong>
              <p>Saturday: 10:00 AM – 2:00 PM EST</p>
              <p>Sunday: Closed</p>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="contact-form-wrap card">
          <h2>Send a Message</h2>
          <form onSubmit={submit}>
            <div className="auth-row">
              <div className="form-group">
                <label className="form-label">Your Name *</label>
                <input name="name" className="form-input" value={form.name} onChange={handle} required />
              </div>
              <div className="form-group">
                <label className="form-label">Email *</label>
                <input name="email" type="email" className="form-input" value={form.email} onChange={handle} required />
              </div>
            </div>
            <div className="auth-row">
              <div className="form-group">
                <label className="form-label">Phone</label>
                <input name="phone" type="tel" className="form-input" value={form.phone} onChange={handle} />
              </div>
              <div className="form-group">
                <label className="form-label">Subject *</label>
                <select name="subject" className="form-input form-select" value={form.subject} onChange={handle} required>
                  <option value="">Select a topic</option>
                  <option>Order Inquiry</option>
                  <option>Product Questions</option>
                  <option>Technical Research Support</option>
                  <option>Bulk / Wholesale</option>
                  <option>Returns & Refunds</option>
                  <option>Other</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Message *</label>
              <textarea name="message" className="form-input" value={form.message} onChange={handle} required rows={5} placeholder="Describe your question or research need in detail…" />
            </div>
            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
              {loading ? <span className="spinner" /> : 'Send Message →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
